import { render, staticRenderFns } from "./StrdD_Details.vue?vue&type=template&id=f3610738"
import script from "./StrdD_Details.vue?vue&type=script&lang=js"
export * from "./StrdD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports